@import '../../global/style/utilities/globals';
@import '../../global/style/nano-theme/layers';

:host {
  /**
   * @prop --width: width of the dropdown. Defaults to 'auto'
   * @prop --border: Defaults to #{$layer-border-style}
   * @prop --border-radius: Defaults to #{$layer-bg-color};
   * @prop --background: Defaults to #{$layer-bg-color};
   * @prop --padding: padding of the drop down. Default to '10px 0';
   * @prop --overflow: `nano-menu` with nested `nav-item` requires hidden overflow. This can be overidden;
   * @prop --dropdown-z-index: Defaults to #{$layer-index-dropdown};
   * @prop --min-width: Defaults to 0;
   * @prop --box-shadow: #{$layer-shadow-large};
   */

  --width: auto;
  --border: #{$layer-border-style};
  --border-radius: #{$layer-border-radius};
  --background: #{$layer-bg-color};
  --padding: 10px 0;
  --overflow: hidden;
  --dropdown-z-index: #{$layer-index-dropdown};
  --min-width: 0;
  --box-shadow: #{$layer-shadow-large};

  display: flex;
}

.dropdown {
  position: relative;

  &__trigger {
    display: block;
  }

  &__positioner {
    position: absolute;
    z-index: var(--dropdown-z-index);
    min-inline-size: var(--min-width);

    @media (max-width: 35.9375em) {
      z-index: 100;
    }
  }

  &__panel {
    padding: var(--padding);
    background: var(--background);
    min-inline-size: var(--min-width);
    inline-size: var(--width);
    border: var(--border);
    border-radius: var(--border-radius);
    color: currentColor;
    box-shadow: var(--box-shadow);
    opacity: 0;
    transition: 0.2s ease opacity, 0.2s ease transform, 0.2s ease min-block-size;
    min-block-size: 20px;
    overflow: var(--overflow);
    box-sizing: content-box !important;

    &.loading {
      overflow-y: hidden;
    }

    &.top {
      transform: translateY(-20px) translateZ(0);
    }

    &.bottom {
      transform: translateY(20px) translateZ(0);
    }

    .dropdown__positioner.popover-visible & {
      opacity: 1;
      transform: translateY(0) translateZ(0);
    }

    ::slotted(nano-menu) {
      max-block-size: 50vh;
    }
  }

  &__accessible-title {
    @include visually-hide();
  }
}
